module.exports = __webpack_public_path__ + "static/media/12.4f9322b9.jpg";